export default "__VITE_ASSET__DbWIlWXE__"